import './style.scss';

export function get_in_touch_block() {
  const block = document.querySelector('.get_in_touch_block');
  if (!block) return;
  
}
